import { render, staticRenderFns } from "./ViewUserInterviewAttributes.vue?vue&type=template&id=ddc9efa4"
import script from "./ViewUserInterviewAttributes.vue?vue&type=script&lang=js"
export * from "./ViewUserInterviewAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports